// Example data schema for dynamic tagging
export const DATA_SCHEMA = {
  hero: {
    type: 'object',
    label: 'Hero Section',
    fields: {
      headline: { type: 'text', label: 'Headline' },
      subhead: { type: 'text', label: 'Subheadline' },
      visual_alt: { type: 'text', label: 'Visual Alt Text' },
      primary_cta: { type: 'text', label: 'Primary CTA' },
      secondary_cta: { type: 'text', label: 'Secondary CTA' },
    },
  },
  problem_promise: {
    type: 'object',
    label: 'Problem & Promise',
    fields: {
      problem: { type: 'text', label: 'Problem Statement' },
      consequence: { type: 'text', label: 'Consequence' },
      outcome: { type: 'text', label: 'Desired Outcome' },
      promise: { type: 'text', label: 'Promise' },
    },
  },
  value_evidence: {
    type: 'object',
    label: 'Value Evidence',
    fields: {
      metrics: {
        type: 'array',
        label: 'Metrics',
        itemType: 'object',
        fields: {
          label: { type: 'text', label: 'Label' },
          value: { type: 'text', label: 'Value' },
          context: { type: 'text', label: 'Context' },
        },
      },
      testimonials: {
        type: 'array',
        label: 'Testimonials',
        itemType: 'object',
        fields: {
          quote: { type: 'text', label: 'Quote' },
          author: { type: 'text', label: 'Author' },
          role: { type: 'text', label: 'Role' },
        },
      },
      features: {
        type: 'array',
        label: 'Features',
        itemType: 'object',
        fields: {
          title: { type: 'text', label: 'Title' },
          description: { type: 'text', label: 'Description' },
        },
      },
    },
  },
  offer: {
    type: 'object',
    label: 'Offer Section',
    fields: {
      how_it_works: {
        type: 'array',
        label: 'How It Works Steps',
        itemType: 'text',
      },
      what_you_get: {
        type: 'array',
        label: 'What You Get',
        itemType: 'text',
      },
      pricing_teaser: { type: 'text', label: 'Pricing Teaser' },
      only_factor: { type: 'text', label: 'Unique Factor' },
    },
  },
  objections: {
    type: 'object',
    label: 'Objections',
    fields: {
      faqs: {
        type: 'array',
        label: 'Frequently Asked Questions',
        itemType: 'object',
        fields: {
          q: { type: 'text', label: 'Question' },
          a: { type: 'text', label: 'Answer' },
        },
      },
      risk: {
        type: 'array',
        label: 'Risk Mitigation',
        itemType: 'text',
      },
      privacy: { type: 'text', label: 'Privacy Statement' },
    },
  },
  conversion: {
    type: 'object',
    label: 'Conversion',
    fields: {
      form_CTA: { type: 'text', label: 'Call to Action' },
      micro_incentive: { type: 'text', label: 'Micro Incentive' },
      form_fields: {
        type: 'array',
        label: 'Form Fields',
        itemType: 'text',
      },
      reassurance: { type: 'text', label: 'Reassurance Text' },
    },
  },
  supporting_images: [
    {
      name: "hero"
    },
    {
      name: "image_1"
    },
    {
      name: "image_2"
    },
    {
      name: "image_3",
    }
  ],
  company_information: {
    type: 'object',
    label: 'Company Information',
    fields: {
      company: { type: 'text', label: 'Name' },
      contact: { type: 'text', label: 'Email' },
      phone_number: { type: 'text', label: 'Phone Number' },
      social_links: {
        type: 'array',
        label: 'Social Links',
        itemType: 'object',
        fields: {
          type: { type: 'text', label: 'Type' },
          url: { type: 'text', label: 'URL' },
        },
      },
      address: { type: 'text', label: 'Address' },
    },
  },
}

// Example data
export const EXAMPLE_DATA = {
  hero: {
    headline: 'Enjoy Fresh Coffee Delivered to You',
    subhead:
      'Subscribe for premium coffee and never run out of your favorite brew.',
    visual_alt: 'A steaming cup of coffee with coffee beans',
    primary_cta: 'Subscribe Now',
    secondary_cta: 'Explore Our Story',
  },
  problem_promise: {
    problem: 'Running out of coffee can ruin your day.',
    consequence: 'You may have to settle for inferior options.',
    outcome: 'Consistent access to your favorite coffee.',
    promise: 'Convenient delivery ensures you always have fresh coffee.',
  },
  value_evidence: {
    metrics: [
      {
        label: 'Average customer rating',
        value: '4.6/5',
        context: 'Sample metric — replace with real data',
      },
      {
        label: 'Orders fulfilled this month',
        value: '120',
        context: 'Sample metric — replace with real data',
      },
      {
        label: 'Repeat customers rate',
        value: '62%',
        context: 'Sample metric — replace with real data',
      },
      {
        label: 'On-time pickup rate',
        value: '98%',
        context: 'Sample metric — replace with real data',
      },
      {
        label: 'On-time pickup rate',
        value: '98%',
        context: 'Sample metric — replace with real data',
      },
      {
        label: 'On-time pickup rate',
        value: '98%',
        context: 'Sample metric — replace with real data',
      },
    ],
    testimonials: [
      {
        quote: 'Beautifully made and exactly what I wanted.',
        author: 'Ada O.',
        role: 'Sample customer — replace',
      },
      {
        quote: 'The carrot cake was moist and delicious!',
        author: 'Chinedu K.',
        role: 'Sample customer — replace',
      },
      {
        quote: 'Great service and lovely custom cupcakes for our party.',
        author: 'Mariam S.',
        role: 'Sample customer — replace',
      },
      {
        quote: 'Our wedding cake looked stunning and tasted great.',
        author: 'Tari P.',
        role: 'Sample customer — replace',
      },
      {
        quote: 'Our wedding cake looked stunning and tasted great.',
        author: 'Tari P.',
        role: 'Sample customer — replace',
      },
      {
        quote: 'Our wedding cake looked stunning and tasted great.',
        author: 'Tari P.',
        role: 'Sample customer — replace',
      },
    ],
    features: [
      {
        title: 'Variety of cakes',
        description:
          'Carrot, cheese, gateaux and more for birthdays, weddings and everyday treats.',
      },
      {
        title: 'Custom-designed cupcakes',
        description:
          'Personalized themes and simple messages for parties and gifting.',
      },
      {
        title: 'Wedding & occasion cakes',
        description: 'Tiered or themed cakes tailored to your event.',
      },
      {
        title: 'Pastry snacks',
        description:
          'A selection of bite-size pastries perfect for quick treats.',
      },
      {
        title: 'Pastry snacks',
        description:
          'A selection of bite-size pastries perfect for quick treats.',
      },
      {
        title: 'Pastry snacks',
        description:
          'A selection of bite-size pastries perfect for quick treats.',
      },
    ],
  },
  offer: {
    how_it_works: [
      'Choose your coffee type - index 0',
      'Select your delivery frequency - index 1',
      'Enjoy fresh coffee at home - index 2',
      'Enjoy fresh coffee at home - index 3',
      'Enjoy fresh coffee at home - index 4',
      'Enjoy fresh coffee at home - index 5',
      'Enjoy fresh coffee at home - index 6',
      'Enjoy fresh coffee at home - index 7',
      'Enjoy fresh coffee at home - index 8',
      'Enjoy fresh coffee at home - index 9',
    ],
    what_you_get: [
      'High-quality coffee beans - index 0',
      'Flexible subscription options - index 1',
      'Convenient delivery - index 2',
      'Convenient delivery - index 3',
      'Convenient delivery - index 4',
      'Convenient delivery - index 5',
      'Convenient delivery - index 6',
      'Convenient delivery - index 7',
      'Convenient delivery - index 8',
      'Convenient delivery - index 9',
    ],
    pricing_teaser: '',
    only_factor: 'Get your favorite coffee without the hassle of shopping.',
  },
  supporting_images: [
    {
      name: "hero"
    },
    {
      name: "image_1"
    },
    {
      name: "image_2"
    },
    {
      name: "image_3",
    }
  ],
  objections: {
    faqs: [
      {
        q: 'What if I want to cancel my subscription?',
        a: 'You can cancel anytime without penalties.',
      },
      {
        q: 'How do I choose my coffee?',
        a: 'Select from a variety of options tailored to your taste.',
      },
      {
        q: 'Is there a minimum subscription period?',
        a: 'No, you can adjust your subscription as needed.',
      },
      {
        q: 'How do I choose my coffee?',
        a: 'Select from a variety of options tailored to your taste.',
      },
      {
        q: 'Is there a minimum subscription period?',
        a: 'No, you can adjust your subscription as needed.',
      },
      {
        q: 'How do I choose my coffee?',
        a: 'Select from a variety of options tailored to your taste.',
      },
      {
        q: 'Is there a minimum subscription period?',
        a: 'No, you can adjust your subscription as needed.',
      },
      {
        q: 'How do I choose my coffee?',
        a: 'Select from a variety of options tailored to your taste.',
      },
      {
        q: 'Is there a minimum subscription period?',
        a: 'No, you can adjust your subscription as needed.',
      },
    ],
    risk: [],
    privacy: 'Your information is secure and will not be shared.',
  },
  conversion: {
    form_CTA: 'Start Your Subscription',
    micro_incentive: 'Join our coffee community today!',
    form_fields: ['name', 'email'],
    reassurance: 'No commitment required.',
  },
  company_information: {
    company: "Eadwin's Edibles",
    contact: 'hello@eadwinsedibles.example',
    phone_number: '+000-000-0000',
    social_links: [
      {
        type: 'instagram',
        url: 'https://instagram.com/eadwinsedibles',
      },
      {
        type: 'facebook',
        url: 'https://facebook.com/eadwinsedibles',
      },
    ],
    address: 'Port Harcourt, Nigeria',
  },
}
